import {
  ActionType,
  IResendMessageResponse,
  IResendMessagePayload,
} from "models/messagemanagement/resendMessage";

export const resendMessageAction = (payload: IResendMessagePayload) => {
  return {
    type: ActionType.RESEND_MESSAGE,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.RESEND_MESSAGE_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IResendMessageResponse) => {
  return {
    type: ActionType.RESEND_MESSAGE_SUCCESS,
    payload,
  };
};

export const handleResetAction = () => {
  return {
    type: ActionType.RESEND_MESSAGE_RESET,
  };
};
